import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import { MobileSummaryCard, Typography, useDevice } from 'seagull';
import s from './TriageRow.module.scss';
export const TriageRow = (param)=>{
    let { label, children, testId, wrapperTestId, mobile } = param;
    const { isMobileDevice } = useDevice();
    const sectionClassName = cn(s.section, {
        [s.sectionMobile]: isMobileDevice
    });
    const content = isMobileDevice && mobile ? /*#__PURE__*/ _jsx("div", {
        "data-testid": testId,
        children: /*#__PURE__*/ _jsx(MobileSummaryCard, {
            error: mobile.error,
            items: [
                {
                    title: label,
                    body: mobile.body,
                    bodyTestId: mobile.bodyTestId,
                    actions: [
                        {
                            bi: {
                                name: 'triage_row_edit'
                            },
                            type: 'edit',
                            testId: mobile.editTestId,
                            onClick: mobile.onEdit
                        }
                    ]
                }
            ]
        })
    }) : /*#__PURE__*/ _jsxs("div", {
        "data-testid": testId,
        className: cn(s.row, {
            [s.rowMobile]: isMobileDevice
        }),
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                className: s.label,
                children: label
            }),
            typeof children === 'string' ? /*#__PURE__*/ _jsx(Typography, {
                weight: "normal",
                className: s.value,
                children: children
            }) : /*#__PURE__*/ _jsx("div", {
                className: s.value,
                children: children
            })
        ]
    });
    return /*#__PURE__*/ _jsx("div", {
        "data-testid": wrapperTestId,
        className: sectionClassName,
        children: content
    });
};
